import React from 'react';
import moment from 'moment';
import { get } from 'lodash';
import { SubmissionError } from 'redux-form';
import { fetchPayoutsCSV, submitCsv } from '../../../app-main/actions/payouts';
import { generateCSV, downloadCSV } from '../utils/utils';
import { FormattedMessage } from 'react-intl';

const onSubmitCsvDateForm = (values, dispatch, props) => {
  const { to, from } = values;
  const ssoId = get(props, 'profile.data.SSOid', '');
  const token = get(props, 'auth.accessToken', '');
  const query = `?executed_after=${moment(from).toISOString()}&executed_before=${moment(to).toISOString()}&before_comparison_type=inclusive`;
  const formattedFrom = moment(from).format('YYYY-MM-DD');
  const formattedTo = moment(to).format('YYYY-MM-DD');
  const errorMessage = <FormattedMessage id="hosting.on_submit_csv_date_form.error_message" defaultMessage="Something happened. Please refresh and try again later." />;

  dispatch(submitCsv(true));
  analyticsIntegrations.payoutsExported(ssoId, formattedFrom, formattedTo);
  return dispatch(fetchPayoutsCSV(ssoId, token, query))
    .then((res) => generateCSV(get(res, 'results', [])))
    .then((csvString) => downloadCSV(csvString, formattedFrom, formattedTo))
    .then(() => {
      dispatch(submitCsv(false));
    })
    .catch(() => {
      throw new SubmissionError({
        _error: errorMessage
      });
    });
};

export default onSubmitCsvDateForm;
